import React, { useState } from "react";

import IconHover from "../iconHover/iconHover";
import { Image } from "@chakra-ui/react";
import { isNotEmptyOrNull } from "../../../utils/common-utils";

const GetAdditionalTaskButtons = ({ image, onHoverChange, text }) => {
  const [isIconHover, setIsIconHover] = useState(false);

  const handleMouseEnter = () => {
    setIsIconHover(true);
    onHoverChange(true);
  };

  const handleMouseLeave = () => {
    setIsIconHover(false);
    onHoverChange(false);
  };
  return (
    <>
      <Image
        position={"relative"}
        src={image}
        width={"24px"}
        height={"24px"}
        borderRadius={"4px"}
        borderWidth={"1px"}
        borderColor={"#E5E5F1"}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
      {isIconHover && isNotEmptyOrNull(text) && <IconHover text={text} />}
    </>
  );
};

export default GetAdditionalTaskButtons;
